import { ChangeEvent } from 'react';
import { OutlinedInput, OutlinedInputProps, useTheme } from '@mui/material';
import {
  CustomCurrencyInputContainer,
  InputLabelContainer,
  TextFieldArea,
} from './styles';
import { InputError, TextM } from '../typography';
import { InfoRounded } from '@mui/icons-material';

export interface ICustomCurrencyInputProps extends OutlinedInputProps {
  labelValue?: string;
  value: string;
  validationError?: string;
  withSelect?: boolean;
  information?: string;
  withLeftSelect?: boolean;
  handleInputChange: (
    evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

const CustomCurrencyInput = ({
  labelValue,
  handleInputChange,
  value,
  validationError,
  withSelect,
  information,
  withLeftSelect,
  ...props
}: ICustomCurrencyInputProps) => {
  const theme = useTheme();

  return (
    <CustomCurrencyInputContainer
      withSelect={withSelect}
      withLeftSelect={withLeftSelect}
    >
      {labelValue && <InputLabelContainer>{labelValue}</InputLabelContainer>}
      <TextFieldArea
        className={withLeftSelect ? '' : 'text-field-area'}
        withLeftSelect={withLeftSelect}
        disabled={props.disabled}
      >
        <TextM
          style={{
            margin: '0px',
            zIndex: '99',
            color: props.disabled ? theme.palette.grey[500] : 'black',
          }}
        >
          R$
        </TextM>

        <OutlinedInput
          value={value}
          type={'text'}
          onChange={(e) =>
            handleInputChange ? handleInputChange(e) : undefined
          }
          {...props}
        />
      </TextFieldArea>
      {validationError && <InputError>{validationError}</InputError>}
      {information && !validationError && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '5px',
            marginBottom: '-3rem',
          }}
        >
          <InfoRounded style={{ width: '19px', marginRight: '8px' }} />
          <small>{information}</small>
        </div>
      )}
    </CustomCurrencyInputContainer>
  );
};

export default CustomCurrencyInput;
